import { AfRoutes } from '../routes';

export const afCloudPortalAdminItems = [
  {
    text: "TOOLBAR.USER-MANAGEMENT", path: `${AfRoutes.companyAdminDashboard}`
  },
  {
    text: "TOOLBAR.SETTINGS", path: `${AfRoutes.settingsDashboard}`
  }
];

export const afCustomerManagerItems = [
  {
    text: "TOOLBAR.CUSTOMERS", path: `${AfRoutes.customersDashboard}`
  }
];

export const aclsItems = [
  {
    text: 'TOOLBAR.CLOUD-LICENSE-SERVER',
    path: `${AfRoutes.cloudLicenseServerDashboard}`,
  },
];

export const welcomeItems = [
  {
    text: "TOOLBAR.WELCOME", path: `${AfRoutes.welcomePage}`
  }
];

/////////////////////////////////////////////////////////////////////////

export const customerItems = [
  {
    text: "TOOLBAR.CLOUD-APPLICATIONS", path: `${AfRoutes.cloudApplicationDashboard}`
  },
];

export const carBodyPlannerItems = [
  {
    text: "CarBodyPlanner", path: `${AfRoutes.carBodyPlannerDashboard}`
  },
];

export const feasibilityAiItems = [
  {
    text: "Feasibility-AI", path: `${AfRoutes.feasibilityAiDashboard}`
  },
];
